import React, { useState } from "react"
import withStyles from "react-jss"
import fonts from "./assets/fonts"
import globalStyles, {
  HEADER_FADEOUT,
  QUIZ_FADEOUT,
  RESULTS_FADEOUT,
} from "./data/globalStyles"
import { Header, Quiz, Results } from "./layouts"
// import { rawData } from "./data/rawData"
// import { formatFinalData } from "./utils/helper"

const styles = {
  ...fonts,
  ...globalStyles,
  app: {
    // height: "100vh",
  },
}

const App = ({ classes }) => {
  const [show, setShow] = useState({
    intro: true,
    quiz: false,
    results: false,
    // results: true,
  })
  // intro || quiz || results
  const [section, setSection] = useState("intro")
  // const [section, setSection] = useState("results")

  const goToQuiz = ({ animationName }) => {
    if (animationName.includes(HEADER_FADEOUT)) {
      setSection("quiz")
    }
  }

  const goToResults = ({ animationName }) => {
    if (animationName.includes(QUIZ_FADEOUT)) {
      setSection("results")
    }
  }

  const goBackToHeader = ({ animationName }) => {
    if (animationName.includes(RESULTS_FADEOUT)) {
      setSection("intro")
    }
  }

  // useEffect(() => {
  //   const test = formatFinalData(rawData)
  //   console.log(test)
  // }, [])

  const [customizedMenu, setCustomizedMenu] = useState([])
  const [resetQuiz, setResetQuiz] = useState(false)

  return (
    <div className={classes.app}>
      <Header
        show={show.intro}
        setShow={setShow}
        section={section}
        onAnimationEnd={goToQuiz}
      />
      <Quiz
        show={show.quiz}
        setShow={setShow}
        section={section}
        onAnimationEnd={goToResults}
        setCustomizedMenu={setCustomizedMenu}
        resetQuiz={resetQuiz}
        setResetQuiz={setResetQuiz}
      />
      <Results
        show={show.results}
        setShow={setShow}
        section={section}
        onAnimationEnd={goBackToHeader}
        ids={
          customizedMenu
          // [1]
        }
        setResetQuiz={setResetQuiz}
      />
    </div>
  )
}

export default withStyles(styles)(App)
